import { instance } from "libs/api";

import { ApiRoutesWhatsAppAdProducts } from "../../constants";
import {
  AdProductsListResponse,
  ListAdProductsParams
} from "../../whatsappAdProducts.types";

export const requestGetAdProducts = async (
  params: ListAdProductsParams
): Promise<AdProductsListResponse> => {
  return await instance.get(ApiRoutesWhatsAppAdProducts.AdProducts, { params });
};
